module.exports = __webpack_public_path__ + "static/media/ic_arrow_left_bold.fd483eb4.svg";